import React from "react"
import { shallowEqual, useDispatch } from "react-redux";
import { Modal } from "rsuite";
import { useAppSelector } from "../../core/redux";
import { ActionsModal } from "../../core/redux/slices/sliceModal";
import { EnumModals } from "../../libs";
import { ModalData } from "./ModalData";

function CommonModalComponent(){
    const Data = ModalData.CommonModal;
    const store = useAppSelector(state=> ({
        show:state.modal.openedModals.includes(EnumModals.COMMON_MODAL),
    }),shallowEqual);

    const dispatch = useDispatch();

    const handleClose=()=>{
        dispatch(ActionsModal.hideModal(EnumModals.COMMON_MODAL));
    }

    return <Modal open={store.show}>
        <Modal.Body className="m-0">        
            <div className="row g-0 border-bottom">
                {!!Data.headerText && <div className="col-auto flex-grow-1">
                    <span>{Data.headerText}</span>
                </div>}
                <div className="col text-end pb-2">
                    <span onClick={handleClose}>
                        <i className="fa fa-times click"  />
                    </span>
                </div>
            </div>
            <div className="row g-0">
                <div className="col-12">
                    {Data.body}
                </div>
            </div>
        </Modal.Body>
    </Modal>

}

export const CommonModal = React.memo(CommonModalComponent);